import React, {PropTypes} from 'react';
import {FormattedNumber} from 'react-intl';

class Percent extends React.Component {

    static propTypes = {
        value: PropTypes.number.isRequired
    };

    render() {
        const {value} = this.props;

        return (
            <FormattedNumber style="percent" value={typeof value === 'number' ? value / 100 : value} />
        );
    }
}

export default Percent;



// WEBPACK FOOTER //
// ./src/browser/components/numbers/Percent.js